import React from 'react';
import { PreviewHeader } from '@noths/polaris-client-ribbons-design-system';
import getConfig from 'next/config';

import { HiddenPageTitle } from 'src/components/atoms/HiddenPageTitle/HiddenPageTitle';
import { Seo } from 'src/components/atoms/Seo/Seo';
import { Sections } from 'src/components/molecules/Sections/Sections';
import type { ContentPageProps } from 'src/types/PageProps';
import type { SerializedUISection } from 'src/types/Section';
import * as styles from './RibbonsPage.styles';

const {
  serverRuntimeConfig: { CLEAR_PREVIEW_API_URL },
} = getConfig();

const blockHasPageTitle = (blocks: SerializedUISection[]) =>
  blocks.some((block) => block.props.headingIsPageTitle);

export const RibbonsPage = ({
  pageContent: { sections, seo, title },
  pageMetadata: { isPreview },
}: ContentPageProps) => {
  const renderHiddenPageTitle = !blockHasPageTitle(sections);

  return (
    <div css={styles.container}>
      <Seo {...seo} />
      {renderHiddenPageTitle && <HiddenPageTitle>{title}</HiddenPageTitle>}
      {isPreview && <PreviewHeader href={CLEAR_PREVIEW_API_URL} />}
      {sections ? <Sections isPreview={isPreview} sections={sections} /> : null}
    </div>
  );
};
